import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CreateRegistryPayoutAccountSessionMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type CreateRegistryPayoutAccountSessionMutation = {
  __typename?: 'Mutation';
  createRegistryPayoutAccountSession: { __typename?: 'RegistryPayoutAccountSession'; clientSecret: string; publishableKey: string };
};

export const CreateRegistryPayoutAccountSessionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRegistryPayoutAccountSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRegistryPayoutAccountSession' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'clientSecret' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishableKey' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateRegistryPayoutAccountSessionMutationFn = Apollo.MutationFunction<CreateRegistryPayoutAccountSessionMutation, CreateRegistryPayoutAccountSessionMutationVariables>;

/**
 * __useCreateRegistryPayoutAccountSessionMutation__
 *
 * To run a mutation, you first call `useCreateRegistryPayoutAccountSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistryPayoutAccountSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistryPayoutAccountSessionMutation, { data, loading, error }] = useCreateRegistryPayoutAccountSessionMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useCreateRegistryPayoutAccountSessionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRegistryPayoutAccountSessionMutation, CreateRegistryPayoutAccountSessionMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateRegistryPayoutAccountSessionMutation, CreateRegistryPayoutAccountSessionMutationVariables>(
    CreateRegistryPayoutAccountSessionDocument,
    baseOptions,
  );
}
export type CreateRegistryPayoutAccountSessionMutationHookResult = ReturnType<typeof useCreateRegistryPayoutAccountSessionMutation>;
export type CreateRegistryPayoutAccountSessionMutationResult = Apollo.MutationResult<CreateRegistryPayoutAccountSessionMutation>;
export type CreateRegistryPayoutAccountSessionMutationOptions = Apollo.BaseMutationOptions<
  CreateRegistryPayoutAccountSessionMutation,
  CreateRegistryPayoutAccountSessionMutationVariables
>;
